// LockScreenWrapper.tsx
import React, { useState } from "react";
import LockScreen from "../Lockscreen";

interface LockScreenWrapperProps {
  password: string;
  children: React.ReactNode;
}

const LockScreenWrapper: React.FC<LockScreenWrapperProps> = ({
  password,
  children,
}) => {
  const [isUnlocked, setIsUnlocked] = useState(false);

  const handleUnlock = () => {
    setIsUnlocked(true);
  };

  return (
    <>
      {isUnlocked ? (
        children
      ) : (
        <LockScreen unlock={handleUnlock} password={password} />
      )}
    </>
  );
};

export default LockScreenWrapper;
